import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const GetEmployees = createAsyncThunk('get-employees', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-payments/get-employees`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateEmployeeTransaction = createAsyncThunk(
  'employee-transaction-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dphs-payments/store-employee-transaction`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetJournal = createAsyncThunk('journal-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-payments/list-journal`, {params})
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetJournalDetails = createAsyncThunk('journal-list', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-payments/get-journal-details/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintJournal = createAsyncThunk('print-journal', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-payments/print-journal/${id}`)

    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EditEmployeeTransaction = createAsyncThunk(
  'employee-transaction-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/edit-employee-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteEmployeeTransaction = createAsyncThunk(
  'employee-transaction-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/delete-employee-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetEmployeeTransactionReport = createAsyncThunk(
  'get-employee-transaction-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/get-employee-transaction-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EmployeeTransactionPrintReport = createAsyncThunk(
  'employee-transaction-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/employee-transaction-print-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EmployeeTransactionExcelReport = createAsyncThunk(
  'employee-transaction-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/employee-transaction-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const GetCompany = createAsyncThunk('get-company', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-payments/get-company`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateCompanyTransaction = createAsyncThunk(
  'company-transaction-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dphs-payments/store-company-transaction`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteCompanyTransaction = createAsyncThunk(
  'company-transaction-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/delete-company-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditCompanyTransaction = createAsyncThunk(
  'company-transaction-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/edit-company-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetCompanyTransactionReport = createAsyncThunk(
  'get-company-transaction-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/get-company-transaction-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CompanyTransactionPrintReport = createAsyncThunk(
  'company-transaction-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/company-transaction-print-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CompanyTransactionExcelReport = createAsyncThunk(
  'company-transaction-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/company-transaction-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const journalClearAccounts = createAsyncThunk(
  'journal-accounts-clear',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/journal-accounts-clear`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getFinanceReport = createAsyncThunk(
  'get-finance-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}dphs-payments/get-finance-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printFinanceReport = createAsyncThunk(
  'print-finance-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}dphs-payments/print-finance-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const excelFinanceReport = createAsyncThunk(
  'excel-finance-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/excel-finance-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getCashReport = createAsyncThunk('get-cash-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dphs-payments/get-cash-report`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const printCashReport = createAsyncThunk('print-cash-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dphs-payments/print-cash-report`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getStudentBookDue = createAsyncThunk('get-student-book-due', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-payments/get-student-book-due`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeStudentBookDue = createAsyncThunk(
  'student-book-due-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dphs-payments/store-student-book-due`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editStudentBookDue = createAsyncThunk(
  'student-book-due-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/edit-student-book-due/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentBookDue = createAsyncThunk(
  'student-book-due-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/delete-student-book-due/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStudentUniformDue = createAsyncThunk(
  'get-student-uniform-due',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/get-student-uniform-due`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeStudentUniformDue = createAsyncThunk(
  'student-uniform-due-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dphs-payments/store-student-uniform-due`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editStudentUniformDue = createAsyncThunk(
  'student-uniform-due-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/edit-student-uniform-due/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentUniformDue = createAsyncThunk(
  'student-uniform-due-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dphs-payments/delete-student-uniform-due/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type PaymentsState = {
  errors: any
}

const initialState: PaymentsState = {
  errors: '',
}

export const paymentsSlice = createSlice({
  name: 'dphs-payments',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = paymentsSlice.actions
export default paymentsSlice.reducer
